<template>
  <n-modal class="modal-edit" :loading="$var('load')" @close="$emit('close')">
    <h3>Редактировать текст</h3>
    <n-form @submit="submit">
      <n-items>
        <wysiwyg v-model="value" />
        <n-button wide color="primary" type="submit">Сохранить</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'ModalEdit',
  props: [ 'model', 'update', ],
  data() {
    return {
      value: this.model.value,
    }
  },
  methods: {
    submit() {
      this.$var('load', true)
      const data = {
        value: this.value,
      }
      $api.translations.edit(this.model.id, data).then((response) => {
        this.$emit('close')
        this.update()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .modal-edit {
  
  }
</style>
